import { render, staticRenderFns } from "./account-archived-tasks.vue?vue&type=template&id=60aa0477&"
import script from "./account-archived-tasks.vue?vue&type=script&lang=js&"
export * from "./account-archived-tasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports